import { getAxiosApiV2WithAuthorization, getAxiosCmsWithAuthorization } from '@clatter/platform';

const baseUrl = '/microsites';

const micrositesApi = {
  getMicrositeByDocumentId: ({ documentId }) =>
    getAxiosCmsWithAuthorization({
      method: 'get',
      url: `${baseUrl}/${documentId}?populate=pages`,
    }),
  postMicrosite: ({ data }) =>
    getAxiosApiV2WithAuthorization({
      url: baseUrl,
      method: 'post',
      data: data,
    }),
  deleteMicrosite: ({ documentId }) =>
    getAxiosApiV2WithAuthorization({
      url: `${baseUrl}/${documentId}`,
      method: 'delete',
    }),
};

export default micrositesApi;
